import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_share_white",
  "use": "icon-icon_share_white-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-icon_share_white\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M.013.581h16v16h-16z\" /><path d=\"M6.68 2.581v1.334H3.347v9.333h9.333V9.915h1.333v4a.667.667 0 0 1-.666.666H2.68a.667.667 0 0 1-.667-.666V3.248c0-.368.299-.667.667-.667h4Zm5.138 3.138L8.013 9.524l-.942-.943 3.804-3.804L8.68 2.58h5.333v5.334l-2.195-2.196Z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol